import styled from 'styled-components';

export const IntroText = styled.p`
  text-align: center;
  max-width: 700px;
  margin: 0 auto 2rem;
  line-height: 1.6;
`;

export const CategoryContainer = styled.div`
  margin-bottom: 3rem;
  padding: 1.5rem;
  background-color: var(--lightest-gray);
  border-radius: 12px;
  
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  }
  
  @media (max-width: 768px) {
    padding: 1rem;
    margin-bottom: 2rem;
  }
`;

export const CategoryHeader = styled.div`
  margin-bottom: 1.5rem;
  text-align: center;
  
  h3 {
    font-size: 1.5rem;
    color: var(--primary-color);
    margin-bottom: 0.5rem;
  }
  
  p {
    color: var(--text-color);
    margin-bottom: 0;
    max-width: 700px;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const ToolsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.2rem;
  
  @media (max-width: 992px) {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
  
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

export const ToolCard = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 1.5rem;
  height: 100%;
  border-left: 3px solid ${props => props.highlight ? 'var(--primary-color)' : 'transparent'};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  
  @media (max-width: 768px) {
    padding: 1.2rem;
  }
`;

export const ToolName = styled.h4`
  font-size: 1.2rem;
  margin-bottom: 0.8rem;
  color: var(--dark-blue);
`;

export const ToolDescription = styled.p`
  font-size: 0.95rem;
  line-height: 1.5;
  color: var(--text-color);
  flex-grow: 1;
`;

export const ToolLink = styled.a`
  display: inline-block;
  margin-top: 0.8rem;
  color: var(--primary-color);
  font-weight: bold;
  text-decoration: none;
  font-size: 0.9rem;
  
  &:hover {
    text-decoration: underline;
  }
`;

// Animation variants for the component
export const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.4 }
  }
};

export const categoryVariants = {
  hidden: { opacity: 0, y: 10 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { staggerChildren: 0.1 }
  }
};

export const toolVariants = {
  hidden: { opacity: 0, x: -10 },
  visible: { 
    opacity: 1, 
    x: 0,
    transition: { duration: 0.3 }
  },
  hover: {
    scale: 1.02,
    backgroundColor: "rgba(0, 82, 204, 0.05)",
    transition: { duration: 0.2 }
  }
}; 